export const apiMethods = (appUrl) => {
    return [
        {
            name: 'PlayerLogin',
            method: 'PlayerLogin',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return btoa(val);
                    },
                },
                {
                    name: 'terms_check',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return 1;
                    },
                },
            ],
        },
        {
            name: 'ValidateTicket',
            method: 'ValidateTicket',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'ticket1_1_1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ticket1_1_2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ticket1_1_3',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ticket1_2_1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val || '';
                    },
                },
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return '1';
                    },
                },
                {
                    name: 'entry-submit',
                    processArgs: (val) => {
                        return 'SUBMIT+ENTRY';
                    },
                },
                {
                    name: 'promotion',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'ValidateTicketSerial',
            method: 'ValidateTicket',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'ticket1_1_1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val || '';
                    },
                },
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return '1';
                    },
                },
                {
                    name: 'entry-submit',
                    processArgs: (val) => {
                        return 'SUBMIT+ENTRY';
                    },
                },
            ],
        },
        {
            name: 'MyEntries',
            method: 'MyEntries',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'PlayerData',
            method: 'PlayerData',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [],
        },
        {
            name: 'PlayerLogout',
            method: 'PlayerLogout',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [],
        },
        {
            name: 'SetEntryFlashGameFlag',
            method: 'SetEntryFlashGameFlag',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'flag',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'promotion',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'Winners',
            method: 'Winners',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'draw_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'PlayerCancelToken',
            method: 'PlayerCancelToken',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [],
        },
        {
            name: 'PlayerCancel',
            method: 'PlayerCancel',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'token',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
    ];
};
